export default function () {
	// Načtení Facebook SDK
	const loadFacebookSDK = () => {
		// Pokud není facebook-jssdk načten a máme ve stránce .fcb-cont-text
		if (!document.getElementById('facebook-jssdk') && document.querySelector('.fcb-cont-text')) {
			const fbScript = document.createElement('script');
			fbScript.id = 'facebook-jssdk';
			fbScript.src = 'https://connect.facebook.net/cs_CZ/sdk.js#xfbml=1&version=v21.0';
			fbScript.async = true;
			fbScript.defer = true;
			fbScript.onload = () => {
				// fcb claim až po tlačítkách
				setTimeout(() => {
					document.querySelector('.fcb-cont-text').style.display = 'block';
				}, 1000);
			};
			document.body.appendChild(fbScript);
		}
	};

	// Načtení SDK po načtení stránky
	document.addEventListener('DOMContentLoaded', loadFacebookSDK);
}
